export interface IDomain {
    id: string;
    name: string;
}

export interface IDomains {
    domains: IDomain[];
}


